import {createRef, EventHandler, useEffect, useRef, useState} from "react";

import './VideoClippingContainer.scss'

export type VideoClippingConfig = {
    left: number
    height: number
    top: number
    width: number
}

type Props = {
    onChange: (config: VideoClippingConfig) => void
    videoWidth: number
    videoHeight: number
}

export default (props: Props) => {
    const [ config, setConfig ] = useState<VideoClippingConfig>({
        left: 25,
        height: 100,
        top: 0,
        width: 50,
    })

    const ref = createRef<HTMLDivElement>()

    const [ dragging, setDragging ] = useState<boolean>(false)

    const draggingRef = useRef<boolean>()
    draggingRef.current = dragging

    useEffect(() => {
        if (!ref.current) {
            return
        }

        const onStart = () => {
            setDragging(true)
        }

        const onStop = () => {
            setDragging(false)
        }

        const onDrag = (e: any) => {
            // @ts-ignore
            e = e as EventHandler<PointerEvent>
            if (draggingRef.current) {
                e.preventDefault()
                e.stopPropagation()
                const percent = e.movementX * 100 / props.videoWidth

                const newLeft = config.left + percent
                if (newLeft + config.width > 100) {
                    setConfig({
                        ...config,
                        left: 100 - config.width,
                    })
                    return
                }

                setConfig({
                    ...config,
                    left: newLeft,
                })
            }
        }

        ref.current.addEventListener('pointerdown', onStart)
        window.addEventListener('pointerup', onStop)
        window.addEventListener('pointerout', onStop)
        window.addEventListener('pointermove', onDrag)

        return () => {
            if (ref.current) {
                ref.current.removeEventListener('pointerdown', onStart)
            }
            window.removeEventListener('pointerup', onStop)
            window.removeEventListener('pointerout', onStop)
            window.removeEventListener('pointermove', onDrag)
        }
    }, [ref]);

    useEffect(() => {
        if (dragging) {
            document.body.style.cursor = 'ew-resize'
        } else {
            document.body.style.cursor = 'auto'
        }
    }, [dragging]);

    useEffect(() => {
        props.onChange({
            left: parseInt('' + props.videoWidth * (config.left / 100)),
            width: parseInt('' + props.videoWidth * (config.width / 100)),
            top: parseInt('' + props.videoHeight * (config.top / 100)),
            height: parseInt('' + props.videoHeight * (config.height / 100)),
        })
    }, [config]);

    return (
        <div className="video-clipping-container">
            <div className="pre" style={{ width: config.left + '%' }}></div>
            <div className="clip" style={{ width: config.width + '%' }} ref={ref}></div>
            <div className="post" style={{ width: 100 - config.left - config.width + '%' }}></div>
        </div>
    )
}